var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.itemsFiltered),function(item){return _c('nlsn-tree-view-group',{key:item.id,ref:"childs",refInFor:true,attrs:{"search":_vm.search,"preSelect":_vm.preSelect,"item":item},on:{"change":_vm.selectionChanged}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }